import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function ExamsPage() {
  return <InstituteCrudPage config={entityConfigs['exams']} />;
}
